import {http} from './Config' 

export default{

    post: (avaliacao)=>{
       return http.post( `https://e00fsp7lpg.execute-api.us-east-1.amazonaws.com/dev/valuation20/create/`, avaliacao)
    }
}